export const getBgStatus = (status: string) => {
  switch (status) {
    case '2002': //on pickUp
      return '#DCF3C280';
    case '2003': //Collected
      return '#DCF3C280';
    case '3001': // Stored
      return '#867AF91A';
    case '4001': //onRoadToDelivery
      return '#D6F2DF';
    case '4002': //delivered
      return '#D6F2DF';
    case '5002': //Returned
      return '#F8EECF';
    case '6001': //onReview
      return '#F8EECF';
    case '9001': //OnP99
      return '#43425D1A';
    case '8003': //cancelled
      return '#F6DDDC';
    case 'fulfilled':
      return '#DCF3C280';
    case 'canceled':
      return '#F6DDDC';
    case 'pending':
      return '#F8EECF';
    default:
      return 'grey';
  }
};
export const getLbColorStatus = (status: string) => {
  switch (status) {
    case '4001': //onRoadToDelivery
      return '#87C34A';
    case '2003': //Collected
      return '#87C34A';
    case '4002':
      return '#3FC468';
    case '5002':
      return '#FBC30E';
    case '8003':
      return '#EC645E';
    case '9001':
      return '#43425D';
    case '3001':
      return '#867AF9';
    case '2002':
      return '#87C34A';
    case '6001':
      return '#FBC30E';
    case 'fulfilled':
      return '#87C34A';
    case 'canceled':
      return '#EC645E';
    case 'pending':
      return '#FBC30E';
    default:
      return 'white';
  }
};

export const labels: Array<Record<string, string>> = [
  {
    stored: 'En almacén',
    onP99: 'En punto99',
    onRoadToDelivery: 'En camino al destino',
    totalProcess: 'En curso',
  },
  {
    delivered: 'Entregados',
    returned: 'Retornos',
    cancelled: 'Cancelados',
    totalHistory: 'Completados',
  },
  {
    incident: 'Con incidencia',
    onReview: 'En revisión',
    totalReview: 'En revisión total',
  },
];

export const pickupStatusColor = (status: string) => {
  switch (status) {
    case 'En recolección':
      return { color: 'rgba(63, 196, 104, 1)', bg: 'rgba(214, 242, 223, 1)' };
    case 'Borrador':
      return { color: 'rgba(251, 195, 14, 1)', bg: 'rgba(248, 238, 207, 1)' };
    case 'Confirmado':
      return { color: 'rgba(134, 122, 249, 1)', bg: 'rgba(234, 233, 246, 1)' };
    default:
      return { color: 'rgba(36, 36, 36, 0.73)', bg: 'rgba(36, 36, 36, 0.22)' };
  }
};

export const getBgStatusFF = (status: string) => {
  switch (status) {
    case 'fulfilled':
      return '#DCF3C280';
    case 'canceled':
      return '#F6DDDC';
    case 'pending':
      return '#F8EECF';
    case 'processing':
      return '#F8EECF';
    default:
      return '#DCF3C280';
  }
};

export const getLbColorStatusFF = (status: string) => {
  switch (status) {
    case 'fulfilled':
      return '#87C34A';
    case 'canceled':
      return '#EC645E';
    case 'pending':
      return '#FBC30E';
    case 'processing':
      return '#FBC30E';
    default:
      return '#87C34A';
  }
};

export const getStatusLabel = (status: string) => {
  const labels: Record<string, string> = {
    fulfilled: 'Entregada',
    canceled: 'Cancelada',
    pending: 'Pendiente',
    processing: 'En proceso',
  };

  return labels[status] || status;
};
